export const isTouch = window.matchMedia("(pointer: coarse)").matches;
export const isMobile = window.matchMedia("(max-width: 480px) and (orientation: portrait)").matches || window.matchMedia("(max-width: 824px) and (orientation: landscape)").matches;
const ua = navigator.userAgent.toLowerCase();
export const isFirefox = ua.indexOf('firefox') > -1;
export const isSafari = ua.indexOf('safari') > -1 && ua.indexOf('chrome') === -1;
export const isChrome = ua.indexOf('safari') > -1 && ua.indexOf('chrome') > -1;